import request from '@/utils/request'

// 查询其他参数配置
export function findOtherParameterConfiguration(params) {
  return request({
    url: `/other_parameter_configuration`,
    method: 'get',
    params: params
  })
}

// 更新其他参数配置
export function updateOtherParameterConfiguration(data) {
  return request({
    url: `/other_parameter_configuration`,
    method: 'put',
    data
  })
}
